import styled from 'styled-components';
import { colors, mediaRetina } from 'theme';

import { ButtonBase } from './ButtonBase';

export const SecondaryButton = styled(ButtonBase)`
  ${({ blue, reverse, light, width }) => {
    const buttonTheme = {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-nested-ternary
      textColor: reverse
        ? 'white'
        : blue
        ? colors.waterBlue
        : colors.battleshipGrey,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-nested-ternary
      borderColor: reverse
        ? 'white'
        : // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line no-nested-ternary
        blue
        ? colors.waterBlue
        : light
        ? colors.aluminum
        : colors.battleshipGrey,
      hoverTextColor: reverse ? colors.waterBlue : colors.turtleGreen,
      hoverBorderColor: reverse ? 'white' : colors.turtleGreen,
      hoverBgColor: reverse ? 'white' : 'transparent',
    };
    return `
      color: ${buttonTheme.textColor};
      width: ${width};
      box-shadow: inset 0 0 0 1px ${buttonTheme.borderColor};
      &:not([disabled]):hover {
        color: ${buttonTheme.hoverTextColor};
        background-color: ${buttonTheme.hoverBgColor};
        box-shadow: inset 0 0 0 1px ${buttonTheme.hoverBorderColor};
        text-decoration: none;
        &:disabled {
          &:hover {
            background-color: transparent;
            box-shadow: inset 0 0 0 1px ${buttonTheme.borderColor};
          }
        }
      }
      ${mediaRetina} {
        box-shadow: inset 0 0 0 1.5px ${buttonTheme.borderColor};
        &:not([disabled]):hover {
          box-shadow: inset 0 0 0 1.5px ${buttonTheme.hoverBorderColor};
        }
      }
    `;
  }}
`;
